<template>
  <b-modal
    id="compose-mail"
    :visible="shallShowEmailComposeModal"
    title="Compose Email"
    modal-class="modal-sticky"
    footer-class="d-flex justify-content-between"
    body-class="p-0"
    size="lg"
    no-fade
    hide-backdrop
    static
    @change="(val) => $emit('update:shall-show-email-compose-modal', val)"
  >
    <!-- Modal Header -->
    <template #modal-header>
      <h5 class="modal-title">ارسال پیام</h5>
      <div class="modal-actions">
        <!-- <feather-icon
          icon="MinusIcon"
          class="cursor-pointer"
          @click="$emit('update:shall-show-email-compose-modal', false)"
        />
        <feather-icon icon="Maximize2Icon" class="ml-1 cursor-pointer" /> -->
        <feather-icon
          icon="XIcon"
          class="ml-1 cursor-pointer"
          @click="$emit('update:shall-show-email-compose-modal', false)"
        />
      </div>
    </template>

    <!-- Modal Footer -->
    <template #modal-footer>
      <!-- Footer: Left Content -->
      <div>
        <b-button
          :disabled="!content || !subject || loading"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="send"
          class="d-flex align-items-center"
          ><span class="mr-50">ارسال</span>
          <b-spinner label="Small Spinner" v-if="loading" small
        /></b-button>
      </div>
    </template>

    <!-- Modal: Body -->
    <b-form>
      <!-- Field: To -->
      <div class="compose-mail-form-field">
        <label for="email-to" class="form-label">به: </label>
        <div class="p-1 w-100">
          <!-- <select-box
          v-model="users"
          multiple
          label="text"
          select="id"
          class="w-100"
          url="user"
          searchable
        /> -->
          <div class="d-flex flex-wrap">
            <div class="col-md-6 px-4 col-12">
              <b-form-group label="ترم" class="w-100">
                <select-box
                  v-model="semester_id"
                  label="text"
                  select="id"
                  class="w-100"
                  url="semester"
                  searchable
                />
              </b-form-group>
            </div>
            <div class="col-md-6 px-4 col-12">
              <b-form-group label="دوره" class="w-100">
                <select-box
                  v-model="course_id"
                  label="text"
                  select="id"
                  class="w-100"
                  url="course"
                  searchable
                />
              </b-form-group>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="col-md-6 px-4 col-12">
              <b-form-group label="جلسه" class="w-100">
                <select-box
                  v-model="session_id"
                  label="text"
                  select="id"
                  class="w-100"
                  url="session"
                  searchable
                />
              </b-form-group>
            </div>
            <div class="col-md-6 px-4 col-12">
              <b-form-group label="رویداد" class="w-100">
                <select-box
                  v-model="event_id"
                  label="text"
                  select="id"
                  class="w-100"
                  url="event"
                  searchable
                />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div
        class="compose-mail-form-field py-1 d-flex justify-content-start flex-wrap"
      >
        <label class="mr-5">ارسال با: </label>
        <b-form-group
          label="sms"
          label-cols="4"
          label-for="sms-type"
          class="col-12 col-md-4 mb-0 d-flex align-items-center"
        >
          <b-form-checkbox id="sms-type" v-model="sms" />
        </b-form-group>
        <b-form-group
          label="email"
          label-cols="4"
          label-for="email-type"
          class="col-12 col-md-4 mb-0 d-flex align-items-center"
        >
          <b-form-checkbox id="email-type" v-model="email" />
        </b-form-group>
      </div>
      <!-- Field: Subject -->
      <div class="compose-mail-form-field">
        <label for="email-subject">موضوع: </label>
        <b-form-input id="email-subject" v-model="subject" />
      </div>

      <!-- Field: content - Quill Editor -->
      <div class="content-editor">
        <editor v-model="content" :content="content" />
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
  BForm,
  BFormInput,
  BAvatar,
  BDropdownDivider,
  BButton,
  BFormGroup,
  BSpinner,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Editor from "@core/components/editor/Editor.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  directives: {
    Ripple,
  },
  components: {
    // BSV
    BDropdown,
    BDropdownItem,
    BForm,
    BFormInput,
    BAvatar,
    BDropdownDivider,
    BButton,
    BFormCheckbox,
    // 3rd Party
    Editor,
    SelectBox,
    BFormGroup,
    BSpinner,
  },
  model: {
    prop: "shallShowEmailComposeModal",
    event: "update:shall-show-email-compose-modal",
  },
  props: {
    shallShowEmailComposeModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      types: [
        { text: "به صورت sms", val: "sms" },
        { text: "به صورت email", val: "email" },
      ],
      sms: false,
      email: false,
      content: "",
      subject: "",
      loading: false,
      semester_id: "",
      course_id: "",
      session_id: "",
      event_id: "",
    };
  },
  methods: {
    async send() {
      try {
        this.loading = true;
        let notification = {
          content: this.content,
          subject: this.subject,
        };
        this.email ? (notification.mail = "1") : "";
        this.sms ? (notification.sms = "1") : "";
        this.semester_id ? (notification.semester_id = this.semester_id) : "";
        this.course_id ? (notification.course_id = this.course_id) : "";
        this.session_id ? (notification.session_id = this.session_id) : "";
        this.event_id ? (notification.event_id = this.event_id) : "";
        const { data } = await this.$http.post(
          "/panel/notifications",
          notification
        );
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: `پیام شما با موفقیت ارسال شد`,
              icon: "CoffeeIcon",
              variant: "success",
            },
          },
          { position: "bottom-right" }
        );
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
